
<div id="{{'LoadChart_Planned_' + this.TeamId}}" style="height: 400px;">

</div>


